import { lazy, Suspense } from 'react';
import { Loader } from '@/shared/ui';
import type { Props } from './LineChart';

const Chart = lazy(() =>
  import('./LineChart').then(({ LineChart }) => ({
    default: LineChart,
  })),
);

export function LineChartLazy<T extends string>(props: Props<T>) {
  return (
    <Suspense fallback={<Loader active />}>
      <Chart {...props} />
    </Suspense>
  );
}
